import validateNpmPackageName from 'validate-npm-package-name';

/**
 * 验证项目名称
 */
export function validateProjectName(name: string): boolean | string {
  const result = validateNpmPackageName(name);

  if (result.validForNewPackages) {
    return true;
  }

  const errors = [...(result.errors || []), ...(result.warnings || [])];
  return errors[0] || '项目名称不合法';
}

/**
 * 验证模板名称
 */
export function validateTemplateName(name: string): boolean | string {
  if (!name || name.trim().length === 0) {
    return '模板名称不能为空';
  }

  if (!/^[a-z0-9-_]+$/i.test(name)) {
    return '模板名称只能包含字母、数字、连字符和下划线';
  }

  return true;
}

/**
 * 验证Git地址
 */
export function validateGitUrl(url: string): boolean | string {
  if (!url || url.trim().length === 0) {
    return 'Git地址不能为空';
  }

  // 支持的格式：
  // - https://github.com/user/repo.git
  // - https://codeup.aliyun.com/xxx/yyy/zzz.git
  // - github:user/repo
  // - gitlab:user/repo
  // - gitee:user/repo
  // - codeup:company/project/repo
  const patterns = [
    /^https?:\/\/.+\/.+/,
    /^git@.+:.+\/.+/,
    /^(github|gitlab|gitee|codeup|bitbucket|sourcehut):.+\/.+/,
  ];

  const isValid = patterns.some((pattern) => pattern.test(url));

  if (!isValid) {
    return 'Git地址格式不正确';
  }

  return true;
}

